module.exports = __webpack_public_path__ + "static/img/190725-feature-infant-food-allergy.2658613.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190725-feature-infant-food-allergy.jpg
// module id = Qoxj
// module chunks = 0